import type { SelectorDefinition } from '@exodus/redux-dependency-injection';

import { formatDate, startOfDayTimestampLocal } from '@/utils/datetime';
import type {
  BlinkActionLog,
  UsedBlinkAction,
  UsedBlinkActions,
} from '../../types.js';
import type { Data } from '../initial-state.js';

const groupActionsWithTimeLabels = (actions: UsedBlinkActions) => {
  if (!actions) {
    return [];
  }

  const today = startOfDayTimestampLocal(new Date());
  const yesterday = startOfDayTimestampLocal(new Date(today - 1));

  const sortedActions = Object.values(actions).sort((aAction, bAction) => {
    const a = new Date(aAction.date);
    const b = new Date(bAction.date);

    return b === a ? 0 : b > a ? 1 : -1;
  });

  return sortedActions.reduce((log, action, index, source) => {
    const previousAction: UsedBlinkAction | undefined = source[index - 1];

    const previousActionDate =
      previousAction && startOfDayTimestampLocal(new Date(previousAction.date));
    const currentActionDate = startOfDayTimestampLocal(new Date(action.date));

    if (!previousActionDate || currentActionDate !== previousActionDate) {
      const label =
        currentActionDate === today
          ? 'Today'
          : currentActionDate === yesterday
            ? 'Yesterday'
            : formatDate(currentActionDate);

      log.push({
        id: `label-${label}`,
        type: 'label',
        label,
      });
    }

    log.push({
      ...action,
      type: 'action',
    });

    return log;
  }, [] as BlinkActionLog);
};

const resultFunction = (data: Data) => groupActionsWithTimeLabels(data.actions);

const actionLogDefinition = {
  id: 'actionLog',
  resultFunction,
  dependencies: [
    //
    { selector: 'data' },
  ],
} as const satisfies SelectorDefinition;

export default actionLogDefinition;
